// src/index.ts
var nestedLinksParserPlugin = {
  type: "postProcessor",
  name: "nestedLinksParser",
  process: function(value, _key, options) {
    const linksBlank = options.linksBlank;
    const links = options == null ? void 0 : options.links;
    const classNameAttr = (options == null ? void 0 : options.classNameAttr) ? ` className="${options == null ? void 0 : options.classNameAttr}"` : "";
    const classAttr = (options == null ? void 0 : options.classAttr) ? ` class="${options == null ? void 0 : options.classAttr}"` : "";
    let matchIndex = 0;
    return value.replace(/<a>/g, () => {
      const subStitute = `<a${classNameAttr}${classAttr}${(linksBlank == null ? void 0 : linksBlank[matchIndex]) ? ' target="_blank"' : ""} href="${(links == null ? void 0 : links[matchIndex]) || ""}">`;
      matchIndex++;
      return subStitute;
    });
  }
};
var src_default = nestedLinksParserPlugin;

export { src_default as default, nestedLinksParserPlugin };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map